import React, { useState } from 'react';

// Sub-component to handle individual card logic
const TestimonialCard = ({ t }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="group bg-white p-6 rounded-[2rem] shadow-sm border border-orange-100/50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between">
      <div>
        <div className="flex items-center gap-4 mb-6">
          <div className="relative">
            {/* Fallback Logic: Shows initials if image fails or is loading */}
            {imageError ? (
              <div className="w-14 h-14 rounded-full bg-[#B08968] flex items-center justify-center text-white font-bold text-xl border-2 border-[#B08968]">
                {t.name.charAt(0)}
              </div>
            ) : (
              <img 
                src={t.image} 
                alt={t.name} 
                onError={() => setImageError(true)}
                className="w-14 h-14 rounded-full border-2 border-[#B08968] object-cover group-hover:scale-105 transition-transform"
              />
            )}
            {/* Status Indicator */}
            <div className="absolute -bottom-1 -right-1 bg-green-500 w-4 h-4 rounded-full border-2 border-white"></div>
          </div>
          
          <div>
            <p className="font-bold text-[#4A3728] text-sm leading-tight">{t.name}</p>
            <p className="text-[10px] text-[#B08968] uppercase tracking-wider font-semibold">{t.school}</p>
          </div>
        </div>
        
        <div className="relative">
          <span className="absolute -top-4 -left-2 text-4xl text-orange-100 font-serif leading-none select-none">“</span>
          <p className="text-gray-600 text-sm leading-relaxed relative z-10 italic">
            {t.quote}
          </p>
        </div>
      </div>

      {/* Footer info */}
      <div className="mt-6 flex items-center justify-between border-t border-gray-50 pt-4">
        <div className="flex text-yellow-400 text-[10px]">
          {[...Array(5)].map((_, i) => <span key={i}>★</span>)}
        </div>
        <span className="text-[10px] text-gray-400 font-medium">Verified Student</span>
      </div>
    </div>
  );
};

export default function StudentTestimonials() {
  const testimonials = [
    {
      name: "Chidi from UNILAG",
      school: "University of Lagos",
      image: "https://ui-avatars.com/api/?name=Chidi+Unilag&background=B08968&color=fff&bold=true",
      quote: "OmniClarix turned my 50-page textbook into lesser pages, save me from a lot of exam pressure"
    },
    {
      name: "Amina from ABU",
      school: "Ahmadu Bello University",
      image: "https://ui-avatars.com/api/?name=Amina+Abu&background=4A3728&color=fff&bold=true",
      quote: "I just scan my anatomy notes and it gives me quizzes instantly. It ease me off some stress."
    },
    {
      name: "Emmy from UNN",
      school: "Auchi Polytechnic",
      image: "https://ui-avatars.com/api/?name=Emeka+Unn&background=B08968&color=fff&bold=true",
      quote: "Engineering keywords made easy with your examples. Now I just 'clarify' them and everything clicks."
    },
    {
      name: "Titi from LASU",
      school: "Lagos State University",
      image: "https://ui-avatars.com/api/?name=Titi+Lasu&background=4A3728&color=fff&bold=true",
      quote: "This is amazing, bulky textbook turned into short and very small notes"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-[#FDFBF9]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#4A3728] mb-4">
            Trusted by students across Nigeria
          </h2>
          <p className="text-[#8D7566] font-medium">Join the top performers at your university/polytechnics.</p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
}